import dayjs from 'dayjs'

import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import isBetween from 'dayjs/plugin/isBetween'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)

dayjs.tz.setDefault('America/Sao_Paulo')

export default (context, inject) => {
  context.$dayjs = dayjs
  inject('dayjs', dayjs)
}
